
    import './styles.scoped.css';
    export default {
  "options-list": "awsui_options-list_19gcf_6ilyx_141",
  "decrease-block-margin": "awsui_decrease-block-margin_19gcf_6ilyx_191"
};
  